import styled, { css } from 'styled-components'

import { Button } from '@blade/ui-kit'

export const TradeSettingsButton = styled(Button)<{
  $enabled: boolean
}>`
  --button-border: var(--upA-3);
  --button-color: var(--upA-2);

  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  height: 34px;

  text-align: center;
  text-transform: capitalize;

  ${({ $enabled }) =>
    $enabled &&
    css`
      border: 1px solid var(--button-border);
      background: var(--button-color);
      color: var(--text-12);
    `}

  ${({ $enabled }) =>
    !$enabled &&
    css`
      border: 1px solid var(--background-7);
      color: var(--text-11);
      background: transparent;
    `}


  &:hover {
    border: 1px solid var(--button-border);
    background: var(--button-color);
    color: var(--text-12);
  }
`
